module.exports = __webpack_public_path__ + "static/media/6.259430a7.jpg";